module.exports = __webpack_public_path__ + "static/media/studentBelow.1485fcde.svg";